import { useRouter } from 'next/router';
import React, { useState, useEffect } from 'react';
import SectionBox from '@common/Component/SectionBox/SectionBox';
import Image from 'next/image';
import { QuickLinksStyled } from './QuickLinksStyled';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { clickInteractionQuickLink } from '@common/Utility/analytics-utils';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const QuickLinks = (props) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [userArea, setUserArea] = useState(null);
  const quickLinksArray = props?.data?.links;

  useEffect(() => {
    setUserArea(localStorage.getItem('userArea'));
  }, []);

  return (
    <QuickLinksStyled>
      <SectionBox title="Quick Links" customClass="section-title" customOuterClass="pb-4 whiteBg">
        <div className="quicklinks-wrapper">
          {quickLinksArray.map((item, index) => {
            return (
              <Card
                className={`card-wrapper ${hoveredItem === index ? 'hovered' : ''}`}
                onMouseEnter={() => setHoveredItem(index)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <Card.Body className="quicklinks-body">
                  <a
                    href={generateURL(item?.linkWeb)}
                    onClick={(e) => {
                      clickInteractionQuickLink(item?.title);
                      e.preventDefault();
                      router.push({
                        pathname: generateURL(item?.linkWeb),
                      });
                    }}
                    className="quick-wrapper"
                  >
                    <Image
                      className="quicklinks_image"
                      src={hoveredItem === index ? getImageUrlWithSize(item?.iconHover,32, 32) : getImageUrlWithSize(item?.icon,32, 32)}
                      width={32}
                      height={32}
                    />
                    <div className="title">{item?.title}</div>
                    <div className="arrow"></div>
                  </a>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </SectionBox>
    </QuickLinksStyled>
  );
};

QuickLinks.propTypes = {
  data: PropTypes.array,
};
export default QuickLinks;
